export default __webpack_public_path__ + "static/media/inclusivo.30279434.svg";